import { useEffect } from 'react';
import { goToTopOfPage } from '../../../helper/helper';
import Button from '../../../components/Common/Button';
import { setBookDataModified } from '../../../store/appSlice';
import { AppDispatch } from '../../../store/store';
import { useDispatch } from 'react-redux';
import { updateBookCover } from '../services/story.service';
import { ChooseCoverProps } from '../models/ChooseCoverProps.interface';
import { UserLocalStorageKeysEnum } from '../../../interfaces/user.interface';
import { useStorageObjectUrl } from '../../../services/file.service';

interface CoverItemProps {
  page: any;
  pageIndex: string;
  className: string;
  imageClass: string;
  onCoverSelect: (url: string) => void;
}

const CoverItem = ({ page, pageIndex, className, imageClass, onCoverSelect }: CoverItemProps) => {
  const imageUrl = page.imageURLwebp || page.imageURL;
  const { url: storageUrl } = useStorageObjectUrl(imageUrl);

  return (
    <div
      key={pageIndex}
      className={`${className} ${imageClass}`}
      style={{
        backgroundImage: `url('${storageUrl || '/loading.gif'}')`,
        backgroundSize: 'contain',
        margin: 'auto'
      }}
      onClick={() => {
        onCoverSelect(imageUrl);
      }}
    ></div>
  );
};

const ChooseCover = ({
                       bookData,
                       selectedCoverUrl,
                       setSelectedCoverUrl,
                       setShowBookCover,
                       showBookCover,
                       displayBookPages,
                       setStateData,
                       stateData,
                       className = `w-[14rem] h-[14rem] lg:h-72 lg:w-72 rounded-lg hover:border-4 hover:border-storygreen bg-gray-200 cursor-pointer`
                     }: ChooseCoverProps) => {
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    goToTopOfPage();
  }, []);

  const handleUpdateCover = async () => {
    await updateBookCover(
      bookData?.bookId,
      selectedCoverUrl,
      localStorage.getItem(UserLocalStorageKeysEnum.EDIT_MODE) === 'yes',
      dispatch,
      setBookDataModified,
      setStateData,
      displayBookPages
    );
  };

  return (
    <>
      {Object.entries(bookData?.pages ?? {}).map(([pageIndex, page]: [string, any]) => {
        const isSelected = selectedCoverUrl === (page.imageURLwebp || page.imageURL);
        const imageClass = isSelected ? 'border-4 border-storyblue' : selectedCoverUrl ? 'opacity-50' : '';

        return (
          <CoverItem
            key={pageIndex}
            page={page}
            pageIndex={pageIndex}
            className={className}
            imageClass={imageClass}
            onCoverSelect={setSelectedCoverUrl}
          />
        );
      })}

      <div
        className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 text-center mt-8 w-full flex gap-4 justify-center"
      >
        <Button
          title=" Close"
          onClick={() => {
            setShowBookCover(!showBookCover);
            setStateData({ ...stateData, showDownloadPDF: true });
          }}
          className="submit-button flex justify-center gap-3 max-w-7xl bg-storyblueSecondLightText  text-white font-bold rounded-2xl px-4 py-2 text-base items-center"
        />
        <Button
          title="Choose Cover"
          disabled={!selectedCoverUrl}
          onClick={() => {
            setShowBookCover(!showBookCover);
            handleUpdateCover();
          }}
          className={`submit-button whitespace-nowrap flex justify-center gap-3 max-w-7xl bg-storyblue text-white font-bold rounded-2xl px-4 py-2 text-base items-center ${selectedCoverUrl ? '' : 'opacity-50'
          }`}
        />
      </div>
    </>
  );
};

export default ChooseCover;
